<template>
  <div class="h-screen flex overflow-hidden bg-white">
    <AppSidebar :sidebar-open="sidebarOpen" @toggle-sidebar="sidebarOpen = !sidebarOpen" />

    <!-- Main Content -->
    <div class="flex flex-col w-0 flex-1 overflow-hidden">
      <main
        class="flex-1 relative z-0 overflow-y-auto focus:outline-none bg-gray-100"
        tabindex="0"
      >
        <AppPageHeader :title="title" @toggle-sidebar="sidebarOpen = !sidebarOpen" />
        <slot />

        <AppNotificationFeed />
      </main>
    </div>
  </div>
</template>

<script>
import AppNotificationFeed from '@/components/Notifications/AppNotificationFeed.vue';
import AppSidebar from './partials/AppSidebar.vue';
import AppPageHeader from './partials/AppPageHeader.vue';

export default {
  components: {
    AppSidebar,
    AppPageHeader,
    AppNotificationFeed,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sidebarOpen: false,
    };
  },
};
</script>
